import AvatarStack from "@pathwright/ui/src/components/avatar/AvatarStack"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { ConnectStores } from "lib/core/store"
import "./MessageTo.css"

const MessageTo = (props) => {
  const { context, context_loading, context_error } = props
  const { user_stack, user_count } = context || {}
  return (
    <div className="MessageTo">
      {context ? (
        <div className="MessageTo__context">
          <label>Send message to</label>
          <div className="MessageTo__users">
            {user_stack && user_stack.length > 0 && (
              <AvatarStack
                users={user_stack}
                size="1.6em"
                itemOffset="-0.4em"
              />
            )}
            {user_count > 1 ? (
              <span>Everyone here</span>
            ) : (
              user_count === 1 &&
              user_stack &&
              user_stack.length === 1 && (
                <span>
                  {user_stack[0].first_name} {user_stack[0].last_name}
                </span>
              )
            )}
            {user_count > 1 && <span>({user_count})</span>}
          </div>
        </div>
      ) : (
        <div className="MessageTo__context">
          <label>
            Send a message&nbsp;
            {context_loading && <LoadingCircle size={16} center={false} />}
          </label>
        </div>
      )}
    </div>
  )
}

MessageTo.displayName = "MessageTo"

const mapStateToProps = (state, ownProps) => {
  const { context, context_loading, context_error } = state.messageStore.state
  return _.assign(
    {},
    {
      context,
      context_loading,
      context_error
    },
    ownProps
  )
}

const stores = [
  { store: "message", watch: ["context", "context_loading", "context_error"] }
]

export default ConnectStores(MessageTo, stores, {}, mapStateToProps)
